import { render, staticRenderFns } from "./ProdImage.vue?vue&type=template&id=36023ce4&"
import script from "./ProdImage.vue?vue&type=script&lang=js&"
export * from "./ProdImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports